export default{
    usTitle:"联系我们",
    usH4:"期待与您合作",
    usSpan:"请留下您的信息，我们将尽快与您联系。",
    first:'名',
    last: '姓氏',
    email:"邮箱",
    phone:"联系电话",
    company:"公司名称",
    message:"留言内容",
    country:"国家/地区",
    state:"州/省/直辖市/自治区",
    city:"城市",
    submit:"提交",
    h4:"欢迎莅临",
    p1:"亚洲, 印度尼西亚：",
    p2:"亚洲，新加坡：",
    hint:"必填项",
    emailHint:"格式错误",
    dialogTitle:'提交成功',
    dislogP:'耐心等待，我们会尽快与您联系。',

}